<script>
import { mapState, mapGetters } from 'vuex'
import Translate from './translate'
import { colorMixin } from '../mixins/colorMixin'
export default {
  data () {
    return {
      loadingCheckingStripe: false
    }
  },
  props: {
    component: Object
  },
  created () {
    if (this.$route.query.checkout) {
      this.$bvModal.show('new-modal-signup')
    }
  },
  components: {
    Translate
  },
  mixins: [colorMixin],
  computed: {
    ...mapState(['subscriptions', 'settings', 'user', 'selectedOrder']),
    ...mapGetters(['loggedIn', 'activeSubscriptionPlan']),
    subscriptions () {
      let sortedPlans = []
      if (
        this.$store.state && this.$store.state.subscriptions && this.$store.state.subscriptions.length > 0 &&
        this.$store.state.subscriptions[0].plans && this.$store.state.subscriptions[0].plans.length > 0
      ) {
        sortedPlans = this.$store.state.subscriptions[0].plans
        sortedPlans.sort((a, b) => {
          return a.amount - b.amount
        })
        return sortedPlans
      } else {
        return sortedPlans
      }
    },
    primaryColor () {
      if (this.component.primaryColor) {
        return this.$_rgba(this.component.primaryColor, 1)
      } else if (this.settings.primaryColor) {
        return this.settings.primaryColor.hex
      } else {
        return ''
      }
    }
  },
  methods: {
    getSavingPrecentage (term) {
      if (this.subscriptions && this.subscriptions.length > 0) {
        let lowestSub
        let lowestSubNickName
        this.subscriptions.forEach(subscription => {
          if (this.getPlanNickName(subscription.interval, subscription.interval_count) === 'daily') {
            lowestSub = subscription
            lowestSubNickName = 'daily'
          } else if (this.getPlanNickName(subscription.interval, subscription.interval_count) === 'weekly' && lowestSubNickName !== 'daily') {
            lowestSub = subscription
            lowestSubNickName = 'weekly'
          } else if (this.getPlanNickName(subscription.interval, subscription.interval_count) === 'monthly' && lowestSubNickName !== 'weekly' && lowestSubNickName !== 'daily') {
            lowestSub = subscription
            lowestSubNickName = 'monthly'
          }
        })
        const highestSub = this.subscriptions.find((subscription) => this.getPlanNickName(subscription.interval, subscription.interval_count) === term)

        const highestSubPrice = this.weeklyPrice(highestSub)
        const lowestSubPrice = this.weeklyPrice(lowestSub)
        const percentage = 100 - ((highestSubPrice / lowestSubPrice) * 100)

        return Math.round(percentage)
      } else {
        return null
      }
    },
    introText (planInterval, intervalCount) {
      if (planInterval === 'month' && intervalCount === 1) {
        return 'checkout.only'
      } else {
        return 'checkout.equal'
      }
    },
    amountCallout (planAmount, planInterval, intervalCount, plan) {
      const isTrial = function (planToTest) {
        if (planToTest.trial_period_days > 0) {
          return true
        } else {
          return false
        }
      }
      if (planInterval === 'month' && intervalCount === 1) {
        return 'checkout.billingFrequency' + `${isTrial(plan) ? ' after the ' + plan.trial_period_days + '-day trial' : ''}`
      } else {
        return '$' + `${(planAmount / 100).toFixed(2)} billed ${this.getPlanNickName(planInterval, intervalCount)}` + `${isTrial(plan) ? ' after the ' + plan.trial_period_days + '-day trial' : ''}`
      }
    },
    getPlanNickName (interval, intervalCount, label) {
      if (label) {
        if (interval === 'year') { return 'checkout.annual.label' }
        if (interval === 'month') {
          if (intervalCount === 1) {
            return 'checkout.month.label'
          }
          if (intervalCount === 3) {
            return 'checkout.quarter.label'
          }
          if (intervalCount === 6) {
            return 'checkout.semiannual.label'
          }
        }
      } else {
        if (interval === 'year') { return 'annually' }
        if (interval === 'month') { if (intervalCount === 1) { return 'monthly' } if (intervalCount === 3) { return 'quarterly' } if (intervalCount === 6) { return 'semi-annually' } }
        if (interval === 'week') { return 'weekly' }
        if (interval === 'day') { return 'daily' }
      }
    },
    monthlyAmount (planAmount, planInterval, intervalCount) {
      const amount = (planAmount / 100).toFixed(2)

      if (planInterval === 'month' && intervalCount === 1) {
        return amount
      } else if (planInterval === 'year') {
        return (amount / 12).toFixed(2)
      } else if (planInterval === 'month' && intervalCount === 3) {
        return (amount / 3).toFixed(2)
      } else if (planInterval === 'month' && intervalCount === 6) {
        return (amount / 6).toFixed(2)
      }
    },
    featuredPrice (plan) {
      if (this.component.featuredPrice) {
        if (this.component.featuredPrice.featureMonthly) {
          return this.getPlanNickName(plan.interval, plan.interval_count) === 'monthly' && this.component.featuredPrice.monthly
        }
        return this.getPlanNickName(plan.interval, plan.interval_count) === 'annually' && this.component.featuredPrice.annual
      }
    },
    setPlanData (plan) {
      this.$store.commit('setSelectedOrder', { plan: plan.id })
      this.$store.commit('setSelectedSubscription', plan)

      if (this.loggedIn) {
        // Show payent modal
        this.loadingCheckingStripe = true
        window.Leanplum.track('Checkout', { action: 'attempted_checkout', user_id: this.user?._id, price_id: plan.id, product_id: plan.product })
        this.$store.dispatch('startSession', { token: this.user.token, prices: [plan.id] })
      } else {
        // Show register modal?
        if (this.settings?.newCheckout?.checkoutImage) {
          this.$bvModal.show('new-modal-signup')
          this.$store.commit('setSelectedOrder', { ...this.selectedOrder, plan: plan.id })
        } else {
          this.$bvModal.show('modal-signup')
        }
      }
    },
    buttonText (plan) {
      if (this.activeSubscriptionPlan && plan.id === this.activeSubscriptionPlan.id) {
        return 'Current Plan'
      } else if (this.component.buttonText) {
        return this.component.buttonText === 'SUBSCRIBE' ? 'checkout.subscribe' : this.component.buttonText
      } else {
        return 'checkout.subscribe'
      }
    },
    weeklyPrice (plan) {
      return plan.interval === 'year' ? plan.amount / 100 / 52
        : plan.interval === 'month' ? plan.amount / 100 / (plan.interval_count * 4)
          : plan.interval === 'week' ? plan.amount / 100
            : 0
    }
  }
}
</script>

<template>
    <div class="subscriptions" v-if="subscriptions.length > 0">
      <div class="radio container--pricing-card" :class="{featured: featuredPrice(plan)}" v-for="(plan) in subscriptions" name="plan-id" v-bind:key="plan.id"
          :style="{'--primary-color': primaryColor, '--fade': 0.2}">
        <div class="card-text">
          <span class="variation"
            v-if="featuredPrice(plan) && featuredPrice(plan).topBanner"
          >{{ featuredPrice(plan).topBanner }}</span>
          <p class="plan-nickname"><Translate :directive="getPlanNickName(plan.interval, plan.interval_count, true)" /></p>
          <p><Translate :directive="introText(plan.interval, plan.interval_count)" /></p>
          <p class="per-term" for="annualy">${{ monthlyAmount(plan.amount, plan.interval, plan.interval_count) }}</p>
          <p>/<Translate directive="checkout.interval" /></p>
          <p><Translate :directive="amountCallout(plan.amount, plan.interval, plan.interval_count, plan)" />
          </p>
        </div>
        <p
          class="discount-code"
          v-if="featuredPrice(plan) && featuredPrice(plan).discountCode"
        >{{ featuredPrice(plan).discountCode }}</p>
        <BaseButton @click="setPlanData(plan)" type="button" :disabled="loadingCheckingStripe || (activeSubscriptionPlan && plan.id === activeSubscriptionPlan.id)" class="btn-round btn-sub-choice">
          <template v-if="!loadingCheckingStripe">
            <Translate :directive=buttonText(plan) />
          </template>
          <b-spinner v-show="loadingCheckingStripe" small type="grow"></b-spinner>
        </BaseButton>
      </div>
    </div>
</template>

<style scoped lang="scss">
  .subscriptions {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    p { margin: 0;}
    @media screen and (max-width: 600px) {
      flex-direction: column-reverse;
      max-width: 100%;
    }
  }
  .variation {
    position: absolute;
    top: -2px;
    right: -2px;
    width: 101%;
    border-top-right-radius: 12px;
    border-top-left-radius: 12px;
    padding: 8px 0;
    background-color: var(--primary-color);
    color: #fff;
    font-weight: bold;
    text-align: center;
    z-index: 2;
  }
  .card-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      margin-bottom: 12px;
    }
    .per-term {
      font-size: 55px;
      line-height: 40px;
      font-weight: 900;
    }
    .plan-nickname {
      margin-bottom: 48px;
    }
  }
  .discount-code {
    color: var(--primary-color);
    border-top: 1px solid var(--primary-color);
    text-align: center;
    padding-top: 8px;
  }
  .container--pricing-card {
    font-family: var(--fontFamily);
    border-radius: 16px;
    box-shadow: 0 4px 10px 0 rgba(35, 31, 32, 0.08);
    background-color: #ffffff;
    position: relative;
    padding: 48px 32px;
    padding-top: 18px;
    max-width: 432px;
    width: 432px;
    height: 430px;
    margin: 0 16px;
    display: flex;
    flex-direction: column;
    input { display: none;}
    @media screen and (max-width: 600px) {
      margin-bottom: 24px;
      width: 100%;
    }
    &.featured {
      border: 4px solid var(--primary-color);
      z-index: 9;
      min-height: 300px;
      button {
        background-color: var(--primary-color);
        font-family: var(--fontFamily);
        font-weight: 600;
        text-transform: uppercase;
        border-radius: 28px;
        padding: 16px 64px;
        display: inline-block;
        border: 1px solid var(--primary-color);
        transition: all ease-in-out 0.25s;
        font-size: clamp(14px, 1vw, 16px);
        color: #fff;
      }
    }
  }
  .btn-sub-choice {
    padding: 16px 0 !important;
    margin-top: auto;
    span {
      white-space: normal
    };
  }
</style>
